import React from 'react'
import PropTypes from 'prop-types'
import { Grid, TextField } from '@material-ui/core'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import { BaseDialog, SectionCard } from 'components'

import constants from 'constants/index'

const ReciptDialog = ({ open, setOpen, approval }) => {
  const { PERSON_APPROVAL_OPTIONS } = constants.documents

  const getStatusLabel = (status) =>
    PERSON_APPROVAL_OPTIONS.find((option) => option.id === String(status))
      ?.name ?? status

  return (
    <BaseDialog
      title="Visualização de Aprovações"
      open={open}
      setOpen={setOpen}
      dialogSize="sm"
      fullWidth
      closeButtonText="Fechar"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="E-mail vinculado"
            type="text"
            color="primary"
            variant="outlined"
            fullWidth
            value={approval?.email ?? ''}
            disabled
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Nome do usuário"
            type="text"
            color="primary"
            variant="outlined"
            fullWidth
            value={approval?.nameConfirmation ?? '-'}
            disabled
          />
        </Grid>

        <Grid item xs={12}>
          <SectionCard title="Aprovações" isTable>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Versão</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{approval?.documentVersionId ?? ''}</TableCell>
                  <TableCell>{getStatusLabel(approval?.status)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </SectionCard>
        </Grid>
      </Grid>
    </BaseDialog>
  )
}

ReciptDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  approval: PropTypes.object,
}

export default ReciptDialog
